export default "__VITE_ASSET__CWUqIFtp__"